import { apiRequest, apiImageRequest } from './apiRequest';
import { CONST } from '../constant';

export const getRules = async () => {
  const response = await apiRequest(`/api/member/rules`, CONST.api_method.get);
  return response.data;
};

export const getCommunityRule = async cid => {
  const response = await apiRequest(`/api/member/community-rule/${cid}`, CONST.api_method.get);
  return response.data;
};

export const getRulesAndState = async () => {
  const response = await apiRequest(`/api/member/rules-and-state`, CONST.api_method.get);
  return response.data;
};

export const saveRuleChecked = async data => {
  const response = await apiRequest(`/api/member/rule-checked`, CONST.api_method.post, data);
  return response.data;
};

/**
 * get login member's settings
 * @returns {Promise}
 */
export const getMemberMyPageSetting = async () => {
  const response = await apiRequest(`/api/member/mypage`, CONST.api_method.get);
  return response.data;
};

/**
 * get login member's settings
 * @returns {Promise}
 */
export const getMemberSetting = async () => {
  const response = await apiRequest(`/api/member/setting`, CONST.api_method.get);
  return response.data;
};

/**
 * update member setting
 * @param data
 * @returns {Promise}
 */
export const updateMemberSetting = async data => {
  const response = await apiRequest(`/api/member/setting`, CONST.api_method.post, data);
  return response.data;
};

/**
 * get member's own covers
 * @param data
 * @returns {Promise}
 */
export const getCovers = async () => {
  const response = await apiRequest(`/api/member/cover`, CONST.api_method.get);
  return response.data;
};

/**
 * update member photo setting
 * @param data
 * @returns {Promise}
 */
export const updateCover = async data => {
  const response = await apiRequest(`/api/member/cover`, CONST.api_method.post, data);
  return response.data;
};

export default {
  getRules,
  getCommunityRule,
  getRulesAndState,
  saveRuleChecked,
  getMemberMyPageSetting,
  getMemberSetting,
  updateMemberSetting,
  getCovers,
  updateCover,
};
